(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["aevin-mobile-menu"] && !Shopify.designMode) return;
  try {
    class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.drawer = this.querySelector('details');
      this.rootPanel = this.querySelector('[data-panel="root"]');
      this.subPanel = this.querySelector('[data-panel="sub"]');
      this.subLabel = this.querySelector('[data-sub-label]');
      this.bindEvents();
    }

    bindEvents() {
      this.querySelector('summary')?.addEventListener('click', this.onSummaryClick.bind(this));
      this.drawer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') this.close();
      });
      this.querySelectorAll('[data-drill]').forEach((btn) => {
        btn.addEventListener('click', () => this.openSub(btn));
      });
      this.querySelector('[data-menu-back]')?.addEventListener('click', () => this.closeSub());
    }

    onSummaryClick(event) {
      const isOpen = this.drawer.hasAttribute('open');
      if (isOpen) event.preventDefault();
      if (isOpen) {
        this.close();
      } else {
        this.openMenuDrawer();
      }
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    openMenuDrawer() {
      this.closeSub();
      requestAnimationFrame(() => this.drawer.classList.add('menu-opening'));
      this.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    openSub(btn) {
      const id = btn.getAttribute('data-sub');
      const label = btn.getAttribute('data-label') || '';
      this.querySelectorAll('.aevin-menu-drawer__sub-list').forEach((list) => {
        list.hidden = list.id !== id;
      });
      if (this.subLabel) this.subLabel.textContent = `${label.toUpperCase()} |`;
      this.rootPanel.hidden = true;
      this.subPanel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      this.querySelector('[data-menu-back]')?.focus();
    }

    closeSub() {
      this.querySelectorAll('[data-drill]').forEach((btn) => btn.setAttribute('aria-expanded', 'false'));
      this.querySelectorAll('.aevin-menu-drawer__sub-list').forEach((list) => {
        list.hidden = true;
      });
      if (this.subPanel) this.subPanel.hidden = true;
      if (this.rootPanel) this.rootPanel.hidden = false;
    }

    close() {
      this.closeSub();
      this.drawer.removeAttribute('open');
      this.drawer.classList.remove('menu-opening');
      this.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    }
  }

  if (!customElements.get('aevin-header-drawer')) {
    customElements.define('aevin-header-drawer', HeaderDrawer);
  }
  } catch(e) { console.error(e); }
})();

})();
